var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-select',{attrs:{"value":_vm.value,"options":[
        { value: 'from', text:'発送人の登録番号', },
        { value: 'to', text:'受取人の登録番号', },
        { value: 'ebay', text:'eBayの登録番号', },
        { value: 'ioss', text:'IOSSの登録番号', },
        { value: 'gb', text:'GB VATの登録番号', },
        { value: null, text:'なし', } ],"get-option-label":function (option) { return option.text },"size":_vm.size,"reduce":function (v) { return v.value; },"filter":_vm.filterOption,"append-to-body":"","calculate-position":_vm.withPopper},on:{"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }